import { colourString } from '../../../library';
import React from 'react';
export function ListIcon(_a) {
    var _b = _a.size, size = _b === void 0 ? 20 : _b, _c = _a.tone, tone = _c === void 0 ? 'accent-3' : _c;
    return (React.createElement("svg", { className: "kplr_listIcon", width: size, height: size, fill: "none", viewBox: "0 0 17 13" },
        React.createElement("path", { fill: colourString(tone), d: "M16.1629 2.48626V.771973H.734375V2.48626H16.1629ZM16.1629 4.20054v1.71429H.734375V4.20054H16.1629ZM16.1629 9.3434V7.62912H.734375V9.3434H16.1629ZM16.1629 12.772v-1.7143H.734375v1.7143H16.1629Z" })));
}
export default ListIcon;
